module.exports = __webpack_public_path__ + "img/story-1.c2a79fe4.png";